import * as React from "react"

const SvgPlayground = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 106.254 127.084"
    xmlSpace="preserve"
    {...props}
  >
    <path
          style={{
            fill: "rgb(185, 185, 185)",
          }}
    d="m31.628 32.976-.012-8.608L2.849 47.045c.04 2.677-.042 5.763 0 8.44l28.767 22.678-.023-8.687L7.98 51.303zM75.33 32.976l.012-8.608 28.767 22.677c-.04 2.677.042 5.763 0 8.44L75.342 78.163l.023-8.687 23.612-18.173zM64.698 21.844h7.871L42.137 78.67h-9.353" />
  </svg>
  
)

export default SvgPlayground;
